import React from 'react'
import PropTypes from 'prop-types'

import BusinessSection from '@/business-section'
import ThreeImages from '@/three-images'
import GetStartedButton from '@/get-started-button'

import coinsGreen from './images/coins_green.svg'
import coinsYellow from './images/coins_yellow.svg'

import './styles.css'

const SectionVoting = ({ data, gray }) => {
  return (
    <BusinessSection
      gray={gray}
      title="Voting tools"
      subtitle="for people´s choice voting"
      topText="Advanced"
      topGreen
    >
      <div className="relative mw560 center mb6">
        <ThreeImages
          left={data.votingImg1.sizes}
          center={data.votingImg2.sizes}
          right={data.votingImg3.sizes}
        />
        <img
          src={coinsYellow}
          className="absolute w128 bottom-0 mv0 z-3 left-0 left--2-l"
          alt="coins"
        />
        <img
          src={coinsGreen}
          className="absolute w128 bottom-0 mv0 z-3 right-0 right--2-l"
          alt="coins"
        />
      </div>

      <GetStartedButton />
    </BusinessSection>
  )
}
SectionVoting.propTypes = {
  data: PropTypes.object,
  gray: PropTypes.bool
}

export default SectionVoting



// WEBPACK FOOTER //
// ./src/components/section-voting/section-voting.js